import React, {useState, useRef, useEffect} from 'react';
import AOS from "aos";
import "aos/dist/aos.css";
import { CountUp } from 'countup.js';
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import Menu from "../include/menu";
import Section2 from "./section2";
import Footer from "../include/footer";
import CompareModal from './CompareModal';
import IntroVideo_popup from "../../PTGC/onboarding/introvideo_popup";

const IndexSections = () => {

  const [introvideo_popupModalOpen, setIntroVideo_popupModalOpen] = useState(false);
  const openIntroVideo = () => setIntroVideo_popupModalOpen(true);
  const closeIntroVideo_popupModal = () => setIntroVideo_popupModalOpen(false);

  const logoRef = useRef(null);
  const [logoVisible, setLogoVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setLogoVisible(true), 300);
  }, []);

  const handleMouseMove = (e) => {
    const logo = logoRef.current;
    const { left, top, width, height } = logo.getBoundingClientRect();

    const x = e.clientX - left - width / 2;
    const y = e.clientY - top - height / 2;

    const rotateX = (-y / 20).toFixed(2);
    const rotateY = (x / 20).toFixed(2);

    logo.style.transform = `rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
  };

  const handleMouseLeave = () => {
    logoRef.current.style.transform = `rotateX(0deg) rotateY(0deg)`;
  };
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration
      once: true,     // whether animation should happen only once
    });
  }, []);

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("chains");
  const openModalWithTab = (tab) => {
    setActiveTab(tab);
    setModalIsOpen(true);
  };
  const closeModal = () => setModalIsOpen(false);
  return (
  <>
  <div onMouseMove={handleMouseMove} onMouseLeave={handleMouseLeave}>
  <Menu />
  <section className=" UFOSEC slideSec ">
  <div className="container">
      <div className="slderIn text-center">
          <div className={`logo-wrapper op0 ${scrolled ? 'scrolled' : '' }`}>
              <img src="./images/UFO_big_circle.svg" className={`img-fluid sliderLogo logoS`} ref={logoRef} alt="Logo" />
          </div>
          <div className={`logo-wrapper logowrapperFixed ${scrolled ? 'scrolled' : '' }`}>
              <img src="./images/UFO_big_circle.svg" className={`img-fluid sliderLogo logoS`} ref={logoRef} alt="Logo" />
          </div>
          <img src="./images/ufo_logoName.svg" className="img-fluid logoName" data-aos="fade-up" data-aos-delay="300" data-aos-duration="1000" />
          <img src="./images/ufo_logoTagline.svg" className="img-fluid logoTagline" data-aos="fade" data-aos-delay="400" data-aos-duration="1400" />
          <div className="d-flex justify-content-center gap-2 flex-wrap mt-3 mb-5">
             <button  onClick={openIntroVideo} style={{minHeight:'50px'}} className="borderbtn mybtn mt-1 btn2images"  data-aos="fade"  data-aos-delay="500" data-aos-duration="1600"><span className="gradient-stroke-text" style={{    fontWeight: '600'}}><span>Intro Video</span><i className="iconimgbtn fa-solid fa-video"></i></span></button>
            <button  onClick={() => openModalWithTab('first')} style={{minHeight:'50px'}} className="borderbtn mybtn mt-1 btn2images"  data-aos="fade"  data-aos-delay="500" data-aos-duration="1600"><span className="gradient-stroke-text" style={{    fontWeight: '600'}}><span>About UFO and PLS</span> <img src="./images/UFO_big_circle.svg" className="img-fluid first" /><img src="./coinimages/0xa1077a294dde1b09bb078844df40758a5d0f9a27.png" className="img-fluid" /> </span></button>
          </div>
      </div>
  </div>
 </section>
 <Section2 />


  <section className="Advantagesec priceStats padsec UFOSEC pt-0">
    <div className="container">
    </div>
  </section>
  <Footer />
  </div>
  <CompareModal
        isOpen={modalIsOpen}
        onClose={closeModal}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />

      <IntroVideo_popup modalIsOpen={introvideo_popupModalOpen} closeModal={closeIntroVideo_popupModal} />
  </>
  );
};

export default IndexSections;